var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "layoutAreaInfo",
      attrs: {
        model: _vm.layoutArea,
        rules: _vm.layoutAreaRules,
        "label-position": "left"
      }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _vm.item != null && _vm.item.level == 2
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("大区名称")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-2x" }, [
                _c("span", [_vm._v(_vm._s(_vm.layoutArea.firstName))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [
              _vm._v(
                _vm._s(
                  _vm.item != null && _vm.item.level == 2 ? "小区" : "大区"
                ) + "名称"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.item.id != null,
                      placeholder: "请输入布放区名称"
                    },
                    model: {
                      value: _vm.layoutArea.name,
                      callback: function($$v) {
                        _vm.$set(_vm.layoutArea, "name", $$v)
                      },
                      expression: "layoutArea.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [
              _vm._v(
                _vm._s(
                  _vm.item != null && _vm.item.level == 2 ? "小区" : "大区"
                ) + "编码"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "code" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入布放区编码" },
                    model: {
                      value: _vm.layoutArea.code,
                      callback: function($$v) {
                        _vm.$set(_vm.layoutArea, "code", $$v)
                      },
                      expression: "layoutArea.code"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("所在楼层")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _vm.item != null && _vm.item.level == 2
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.layoutArea.layoutFloorName == null
                          ? "暂无，请在大区维护"
                          : _vm.layoutArea.layoutFloorName
                      )
                    )
                  ])
                : _c(
                    "el-form-item",
                    { attrs: { prop: "code" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            clearable: ""
                          },
                          on: { change: _vm.changeLayoutFloor },
                          model: {
                            value: _vm.layoutArea.layoutFloorId,
                            callback: function($$v) {
                              _vm.$set(_vm.layoutArea, "layoutFloorId", $$v)
                            },
                            expression: "layoutArea.layoutFloorId"
                          }
                        },
                        _vm._l(_vm.layoutFloorList, function(item) {
                          return _c("el-option", {
                            attrs: { label: item.name, value: item.id }
                          })
                        })
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("需要控温")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.layoutArea.temperFlag,
                    callback: function($$v) {
                      _vm.$set(_vm.layoutArea, "temperFlag", $$v)
                    },
                    expression: "layoutArea.temperFlag"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v("是")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [_vm._v("否")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.layoutArea.temperFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("温度低值(°c)")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "temperLow" } },
                    [
                      _c("el-input", {
                        staticClass: "inline-block width-2x",
                        attrs: { placeholder: "请输入温度" },
                        on: {
                          change: function($event) {
                            _vm.temperLowChange()
                          }
                        },
                        model: {
                          value: _vm.layoutArea.temperLow,
                          callback: function($$v) {
                            _vm.$set(_vm.layoutArea, "temperLow", $$v)
                          },
                          expression: "layoutArea.temperLow"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "inline-block font-orange" }, [
                    _vm._v("只保留两位小数")
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.layoutArea.temperFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("温度高值(°c)")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "temperHigh" } },
                    [
                      _c("el-input", {
                        staticClass: "inline-block width-2x",
                        attrs: { placeholder: "请输入温度" },
                        on: {
                          change: function($event) {
                            _vm.temperHighChange()
                          }
                        },
                        model: {
                          value: _vm.layoutArea.temperHigh,
                          callback: function($$v) {
                            _vm.$set(_vm.layoutArea, "temperHigh", $$v)
                          },
                          expression: "layoutArea.temperHigh"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "inline-block font-orange" }, [
                    _vm._v("只保留两位小数")
                  ])
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-999e6ad2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-999e6ad2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/layoutArea/RetailerLayoutAreaSave.vue
// module id = 3141
// module chunks = 0